import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_playerIdAdapter2h87xjwribaa as get_playerIdAdapter } from '../../../adapter/Adapter.mjs';
import {
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  nullable1in0t8o94jx9t as nullable,
  presentmhd0a0ip21um as present,
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  list2lpjhmv1d2k19 as list,
  obj2vqjd1bjrpmyg as obj,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Badge_ResponseAdapter_instance9mu49fvvgdlz as Badge_ResponseAdapter_instance } from './Badge_ResponseAdapter.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { AvatarType_ResponseAdapter_instance32ktucgjbbtjc as AvatarType_ResponseAdapter_instance } from './AvatarType_ResponseAdapter.mjs';
import { PinInput_InputAdapter_instance7qh971mvyfs7 as PinInput_InputAdapter_instance } from './PinInput_InputAdapter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PinnedPlayerInput1hnlnl1bk4or8 as PinnedPlayerInput } from '../PinnedPlayerInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PinnedPlayerInput_InputAdapterClass;
function PinnedPlayerInput_InputAdapter() {
  if (PinnedPlayerInput_InputAdapterClass === VOID) {
    class $ {
      s41(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      f75(writer, customScalarAdapters, value) {
        writer.k4e('id');
        get_playerIdAdapter().t41(writer, customScalarAdapters, value.o72_1);
        writer.k4e('name');
        get_StringAdapter().t41(writer, customScalarAdapters, value.p72_1);
        writer.k4e('email');
        get_StringAdapter().t41(writer, customScalarAdapters, value.q72_1);
        var tmp = value.r72_1;
        if (tmp instanceof Present()) {
          writer.k4e('badge');
          present(nullable(Badge_ResponseAdapter_instance)).r42(writer, customScalarAdapters, value.r72_1);
        }
        writer.k4e('callSignAdjective');
        get_StringAdapter().t41(writer, customScalarAdapters, value.s72_1);
        writer.k4e('callSignNoun');
        get_StringAdapter().t41(writer, customScalarAdapters, value.t72_1);
        var tmp_0 = value.u72_1;
        if (tmp_0 instanceof Present()) {
          writer.k4e('imageURL');
          present(get_NullableStringAdapter()).r42(writer, customScalarAdapters, value.u72_1);
        }
        var tmp_1 = value.v72_1;
        if (tmp_1 instanceof Present()) {
          writer.k4e('avatarType');
          present(nullable(AvatarType_ResponseAdapter_instance)).r42(writer, customScalarAdapters, value.v72_1);
        }
        writer.k4e('unvalidatedEmails');
        list(get_StringAdapter()).p42(writer, customScalarAdapters, value.w72_1);
        writer.k4e('pins');
        list(obj(PinInput_InputAdapter_instance)).p42(writer, customScalarAdapters, value.x72_1);
      }
      t41(writer, customScalarAdapters, value) {
        return this.f75(writer, customScalarAdapters, value instanceof PinnedPlayerInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'PinnedPlayerInput_InputAdapter', VOID, VOID, [Adapter()]);
    PinnedPlayerInput_InputAdapterClass = $;
  }
  return PinnedPlayerInput_InputAdapterClass;
}
var PinnedPlayerInput_InputAdapter_instance;
function PinnedPlayerInput_InputAdapter_getInstance() {
  return PinnedPlayerInput_InputAdapter_instance;
}
//region block: init
PinnedPlayerInput_InputAdapter_instance = new (PinnedPlayerInput_InputAdapter())();
//endregion
//region block: exports
export {
  PinnedPlayerInput_InputAdapter_instance as PinnedPlayerInput_InputAdapter_instancesqyq5n185zzu,
};
//endregion

//# sourceMappingURL=PinnedPlayerInput_InputAdapter.mjs.map
